import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import applicationModule from './modules/application/module.js';
import candidateModule from './modules/candidate/module.js';
import companyModule from './modules/company/module.js';
import jobsModule from './modules/jobs/module.js';
import sitesModule from './modules/sites/module.js';

export default new Vuex.Store({
  state: {
    defaultHeroImageUrl: '',
    heroImageUrl: '',
    defaultHeroClaim: [{ languageKey: 'de-DE', translation: '' }],
    heroClaim: [{ languageKey: 'de-DE', translation: '' }],
    routeImages: [],
    currentLanguage: 'de-DE'
  },
  getters: {
    heroClaim(state) {
      if (!state.heroClaim) {
        return '';
      }

      const languageClaim = state.heroClaim.filter(
        (x) => x.languageKey === state.currentLanguage
      );
      if (languageClaim.length > 0) {
        return languageClaim[0].translation;
      } else {
        return state.heroClaim[0].translation;
      }
    }
  },
  mutations: {
    resetHeroImage(state) {
      state.heroImageUrl = state.defaultHeroImageUrl;
    },

    setDefaultHeroImage(state, url) {
      state.defaultHeroImageUrl = url;
    },

    setHeroImage(state, url) {
      state.heroImageUrl = url;
    },

    setDefaultHeroClaim(state, claim) {
      state.defaultHeroClaim = claim;
    }, 

    setHeroClaim(state, claim) {
      state.heroClaim = claim;
    },

    resetHeroClaim(state) {
      state.heroClaim = state.defaultHeroClaim;
    },

    setRouteImages(state, routeImages) {
      state.routeImages = routeImages;
    },

    setCurrentLanguage(state, languageKey) {
      state.currentLanguage = languageKey;
    }
  },
  actions: {},
  modules: {
    applicationModule: applicationModule,
    candidateModule: candidateModule,
    companyModule: companyModule,
    jobsModule: jobsModule,
    sitesModule: sitesModule
  }
});
